import { z } from 'zod';
import { UserWithBusiness } from './user';

export type DeepRequired<T> = Required<{ [P in keyof T]: DeepRequired<T[P]> }>;
export type Maybe<T extends any[]> = T extends Array<infer U>
  ? Array<U | undefined>
  : never;

export type ResponseError = {
  description: string;
};

export type PostResponse<T> = {
  data?: T;
  errors: ResponseError[];
};

export enum EntitySearch {
  user = 'user',
}

export const PaginationQueryParams = z
  .object({
    entitySearch: z.nativeEnum(EntitySearch).optional(),
    searchProp: z.string().min(1),
    searchTerm: z.string(),
    page: z.string().transform((val) => parseInt(val, 10)),
    take: z.string().transform((val) => parseInt(val, 10)),
    sortDirection: z.enum(['ASC', 'DESC']).default('DESC'),
    sortProp: z.string().min(1),
    filterProp: z.string().min(1).optional(),
    filterValues: z.string().min(1).optional(),
  })
  .partial()
  .strict();

export type PaginationQueryParams = z.TypeOf<typeof PaginationQueryParams>;
